import React from 'react';
import { 
  BottomNavigation, 
  BottomNavigationAction, 
  Paper, 
  useTheme, 
  useMediaQuery 
} from '@mui/material';
import {
  Restaurant as RestaurantIcon,
  Add as AddIcon,
  Person as PersonIcon,
  Analytics as AnalyticsIcon,
  SupervisorAccount as SupervisorAccountIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { getUserRoleFromToken } from './Layout';

const MobileBottomNav = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  const { role: userRole, isManager } = getUserRoleFromToken();

  if (!isMobile) return null;

  const getNavigationItems = () => {
    const baseItems = [
      {
        label: 'My Requests',
        icon: <RestaurantIcon />,
        path: '/my-requests',
      },
      {
        label: 'New Request',
        icon: <AddIcon />,
        path: '/requests/new',
      },
      {
        label: 'Profile',
        icon: <PersonIcon />,
        path: '/profile',
      },
    ];

    if (userRole === 'admin') {
      baseItems.splice(2, 0, {
        label: 'Analytics',
        icon: <AnalyticsIcon />,
        path: '/admin/order-counts',
      });
    }

    if (isManager) {
      baseItems.splice(-1, 0, {
        label: 'Team',
        icon: <SupervisorAccountIcon />,
        path: '/manager-requests',
      });
    }

    return baseItems;
  };

  const navigationItems = getNavigationItems();
  const currentValue = navigationItems.findIndex(item => 
    location.pathname === item.path || location.pathname.startsWith(item.path)
  );

  const handleChange = (event, newValue) => {
    if (newValue >= 0 && newValue < navigationItems.length) {
      navigate(navigationItems[newValue].path);
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.95) 100%)',
        backdropFilter: 'blur(20px)',
      }}
      elevation={8}
    >
      <BottomNavigation
        value={currentValue}
        onChange={handleChange}
        showLabels
        sx={{
          background: 'transparent',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 12px 8px',
            '&.Mui-selected': {
              color: '#20d5d5',
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.75rem',
                fontWeight: 600,
              },
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.7rem',
              fontWeight: 500,
            },
          },
          '& .MuiSvgIcon-root': {
            fontSize: '1.5rem',
          },
        }}
      >
        {navigationItems.map((item, index) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNav;